import {SCROLL_TO_EVENT_KEY} from './constants';

export const scrollToSection = function (id) {
  const event = new CustomEvent(SCROLL_TO_EVENT_KEY, {
    detail: {id}
  })
  window.top.dispatchEvent(event)
}
